
export const imgServerUrl = 'http://82.156.28.157:9000/prod-api/';
export const uploadUrl = 'http://82.156.28.157:9000/prod-api/';
export const baseServerUrl = 'http://82.156.28.157:9000/prod-api/';
export const shareWebUrl = 'http://82.156.28.157:9000/prod-api/';

